/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './medicine.reducer';

export const MedicineDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const medicineEntity = useAppSelector(state => state.medicine.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="medicineDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.medicine.detail.title">Medicine</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.medicine.id">Id</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.medicine.name">Name</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.name}</dd>
          <dt>
            <span id="tmContains">
              <Translate contentKey="tinyMedicRestApp.medicine.tmContains">Tm Contains</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.tmContains}</dd>
          <dt>
            <span id="usedFor">
              <Translate contentKey="tinyMedicRestApp.medicine.usedFor">Used For</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.usedFor}</dd>
          <dt>
            <span id="tmType">
              <Translate contentKey="tinyMedicRestApp.medicine.tmType">Tm Type</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.tmType}</dd>
          <dt>
            <span id="addedBy">
              <Translate contentKey="tinyMedicRestApp.medicine.addedBy">Added By</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.addedBy}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.medicine.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.timestampentry}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.medicine.active">Active</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.medicine.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.lastupdated}</dd>
          <dt>
            <span id="manufacturer">
              <Translate contentKey="tinyMedicRestApp.medicine.manufacturer">Manufacturer</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.manufacturer}</dd>
          <dt>
            <span id="genericName">
              <Translate contentKey="tinyMedicRestApp.medicine.genericName">Generic Name</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.genericName}</dd>
          <dt>
            <span id="unit">
              <Translate contentKey="tinyMedicRestApp.medicine.unit">Unit</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.unit}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.medicine.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.quantity}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.medicine.price">Price</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.price}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.medicine.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.medicine.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.microSec}</dd>
          <dt>
            <span id="country">
              <Translate contentKey="tinyMedicRestApp.medicine.country">Country</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.country}</dd>
          <dt>
            <span id="maximumDailyDose">
              <Translate contentKey="tinyMedicRestApp.medicine.maximumDailyDose">Maximum Daily Dose</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.maximumDailyDose}</dd>
          <dt>
            <span id="minimumDailyDose">
              <Translate contentKey="tinyMedicRestApp.medicine.minimumDailyDose">Minimum Daily Dose</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.minimumDailyDose}</dd>
          <dt>
            <span id="schedule">
              <Translate contentKey="tinyMedicRestApp.medicine.schedule">Schedule</Translate>
            </span>
          </dt>
          <dd>{medicineEntity.schedule}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.medicine.catalog">Catalog</Translate>
          </dt>
          <dd>{medicineEntity.catalog ? medicineEntity.catalog.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/medicine" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/medicine/${medicineEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MedicineDetail;
